import React from 'react';
import PropTypes from 'prop-types';
import {
  Panel,
  Row,
  Col
 } from 'react-bootstrap';
 import Select from 'react-select';

const JNInitWizardPageTwo = (props) => {
  const {
    handleChangeDirection,
    handleChangeMergeKey,
    handleChangeMergeDomSet,
    merge_options,
    merge_key_chosen
  } = props;
  const dir_options = [
    { value : 'both', label : 'Merge your Hail Trace and Job Nimbus data together' },
    { value : 'into_ht', label : 'Clear Hail Trace data and initialize integration with only Job Nimbus data.' }
  ];
  const key_options = [
    { value : 'email', label : 'Email' },
    { value : 'phone', label : 'Phone Number' }
  ];

  return (
    <div className='jn-init-wizard-pg-two-container'>
      <h4>Choose Your Merge Options :</h4>
      <Panel>
        <p>
          In order to successfully integrate your Hail Trace and Job Nimbus accounts, we will need to merge the
          two sets of data (Hail Trace clients and Job Nimbus contacts) to ensure that all updates to your Hail
          Trace clients can smoothly translate to updating your Job Nimbus contacts, and vice versa.
        </p>
        <Select
          options={dir_options}
          onChange={handleChangeDirection}
          value={merge_options.direction || null}
          placeholder='Choose an option'
        />
      </Panel>
      {merge_options.direction == 'both' ? (
        <div>
          <div className='animated fadeInUp'>
            <h4>Choose a Merge Key :</h4>
            <Panel>
              <p>
                To merge your Hail Trace and Job Nimbus data together, you will need to choose a unique <i>key</i>.{' '}
                The key will be used to compare the two sets of data, and merge data together when the keys match.{' '}
                This is done to prevent duplicates.{' '}
              </p>
              <p>
                For example, assume you chose the 'email' field to be your key. If you have stored a client in your Hail Trace{' '}
                account with the email address 'jon@doe.com', and a contact in your Job Nimbus account with the{' '}
                same email, they will be treated as the same person in the merge process.{' '}
              </p>
              <p>
                Email address or phone number are the only supported options. Keys are{' '}
                case-insesitive, and ignore any spaces, tabs, dashes, or parentheses. For example, the phone numbers <i>555 555 1212</i> and{' '}
                <i>(555)-555 - 1212</i> will be equal.{' '}
              </p>
              <p>
                * The <i>Phone </i>field pertaining to a Hail Trace client will be compared to the <i>Main Phone</i>{' '}
                field in your Job Nimbus account.{' '}
              </p>
              <Select
                options={key_options}
                value={merge_options.merge_key || null}
                onChange={handleChangeMergeKey}
                placeholder='Choose an option'
              />
            </Panel>
          </div>
          {merge_key_chosen ? (
            <Panel>
              <div className='animated fadeUp'>
              </div>
            </Panel>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default JNInitWizardPageTwo;



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-init-wizard-pg-two.js